module.exports = __webpack_public_path__ + "media/images/payments/sepa-dark-70ff7b96b783a7074593f2e29206d67b.svg";